// NEXUS — Currency helpers. Base platform currency: AUD.
// Rates fetched lazily from /api/fx/rates and cached in localStorage for 1 hour.
import api from "./api";

const STORAGE_KEY = "nexus_fx_cache_v1";
const TTL_MS = 60 * 60 * 1000; // 1h

let _inflight = null;

export async function getRates() {
  // Try cache
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const c = JSON.parse(raw);
      if (Date.now() - (c.ts || 0) < TTL_MS && c.rates) return c;
    }
  } catch (_e) { /* ignore */ }
  if (_inflight) return _inflight;
  _inflight = api.get("/fx/rates").then(({ data }) => {
    const cached = { ts: Date.now(), ...data };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cached)); } catch (_e) { /* ignore */ }
    _inflight = null;
    return cached;
  }).catch(() => {
    _inflight = null;
    return { base: "AUD", rates: { AUD: 1 }, symbols: { AUD: "A$" }, nx_to_aud: 0.012 };
  });
  return _inflight;
}

export function convertAud(amountAud, toCcy, rates) {
  if (!rates) return amountAud;
  const r = rates[toCcy] ?? 1;
  return amountAud * r;
}

export function nxToAud(amountNx, nxToAudRate = 0.012) {
  return amountNx * nxToAudRate;
}

export function nxToLocal(amountNx, ccy, fxCache) {
  if (!fxCache) return 0;
  const aud = nxToAud(amountNx, fxCache.nx_to_aud || 0.012);
  return convertAud(aud, ccy, fxCache.rates);
}

export function formatMoney(amount, ccy, fxCache) {
  const sym = (fxCache?.symbols || {})[ccy] || "";
  // Use Intl.NumberFormat where supported; fall back to symbol + fixed(2)
  try {
    const fmt = new Intl.NumberFormat(undefined, {
      style: "currency", currency: ccy, maximumFractionDigits: 2,
    });
    return fmt.format(amount);
  } catch (_e) {
    return `${sym}${amount.toFixed(2)}`;
  }
}

export function formatNx(amountNx, fxCache, ccy) {
  // Returns "1,234 NX · ~A$14.81" (or whatever the user's display ccy is).
  const nx = `${Math.round(amountNx).toLocaleString()} NX`;
  if (!fxCache || !ccy || ccy === "NX") return nx;
  const local = nxToLocal(amountNx, ccy, fxCache);
  return `${nx} · ~${formatMoney(local, ccy, fxCache)}`;
}
